module.exports = __webpack_public_path__ + "static/media/icon_processing.95b40188.svg";